import * as React from 'react';

import { setAgenciesTab, setRealtorsTab } from '../../actions/tabs';
import { useSelector } from 'react-redux';

import { ETabs } from '../../types/redux/tabs';
import { MobileTabs } from '../../components/MobileTabs';
import { getCurrentTab } from '../../selectors/tabs';
import { tabs } from '../../constants/filters';
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch';

export function MobileContainer() {
  const dispatch = useAppDispatch();
  const activeTab = useSelector(getCurrentTab);

  // для RadioButtonGroup нужно заменить ключ на label
  const options = React.useMemo(() => {
    return tabs.map(tab => ({ ...tab, label: tab.title }));
  }, []);

  const changeOption = React.useCallback(
    // oxlint-disable-next-line typescript/no-explicit-any
    (_e: any, value: ETabs) => {
      dispatch((value === ETabs.Realtors ? setRealtorsTab : setAgenciesTab)());
    },
    [dispatch],
  );

  return <MobileTabs activeTab={activeTab} tabs={options} onChange={changeOption} />;
}
